(function () {
    'use strict';
    var controllerId = 'pdpEdit';
    angular.module('app').controller(controllerId, ['$scope','$timeout', '$uibModalInstance', 'datacontext', 'studenteSessionPdp', pdpEditFn]);

    function pdpEditFn($scope, $timeout, $uibModalInstance, datacontext, studenteSessionPdp) {
        $scope.item = {};
        $scope.item.studenteSessionPdp = studenteSessionPdp;
        //Opzioni slider
        $scope.slider = {
            minValue: 10,
            maxValue: 100,
            value: 100,
            options: {
                showSelectionBar: true,
                step: 1,
                precision: 1,
                floor: 0,
                ceil: 100,
                hideLimitLabels: true,
                translate: function (value) {
                    return value + '%';
                }
            }
        };

        $scope.slider.value = studenteSessionPdp.pdp_percentage;
        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
        });
        
        $scope.ok = function (isValid) {
            if (isValid) {
                $scope.item.studenteSessionPdp.pdp_percentage = $scope.slider.value;
                //console.info("$scope.item.studenteSessionPdp", $scope.item.studenteSessionPdp);
                
                datacontext.studenteSession_update($scope.item.studenteSessionPdp).then(function (data) {
                    if (data && data.Id)
                        datacontext.studenteSession_updatePdp(data.Id).then(function (question) {
                            //console.info("question",question)
                        });
                        //data.votoModificato = $scope.item.studenteSession.votoModifica;
                        $uibModalInstance.close(data);
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ripristina = function () {
            $scope.item.studenteSession.voto = ($scope.item.studenteSession.score / $scope.item.studenteSession.totalScore) * $scope.item.votoMax;
            $scope.item.studenteSession.votoCommento = "";
        }
    }
})();